export const configPassword = {
    RequireChangePasswordFirstLogin:'requireChangePasswordFirstLogin',
    NumberOfCharacters:'numberOfCharacters',
    PasswordIncludeSpecialCharacter:'passwordIncludeSpecialCharacter',
    PasswordIncludeNumberCharacter:'passwordIncludeNumberCharacter',
    PasswordIncludeUpercaseCharacter:'passwordIncludeUpercaseCharacter',
    TimeChangePassword:'timeChangePassword',
    NumberWrongPassword:'numberWrongPassword',
};
